export const environment = {
    production: true,
    local: 'prod',
    api: '',
    security_auth_path: '/svc-security-auth', // gateway do auth NOVO (OpenIddict / cfoab.services.auth)
    security_auth_legacy_path: '/security-auth', // gateway do auth LEGADO (IS4 IdentityServer, issuer .../security-auth)
    // Site key do reCAPTCHA (público) — produção.
    recaptcha_site_key: '6Ldrqy8tAAAAABs27H3Y55Un22qxoJ2s04adff7-',
    // Auth NOVO (OpenIddict / v2) — slot próprio para não colidir com o token legado compartilhado.
    oab_access_token: 'oab-access-token-v2',
    oab_id_token: 'oab-id-token-v2',
    // Auth LEGADO (IS4) — usado apenas quando o Security faz login no modo broker para apps legados.
    oab_access_token_legacy: 'oab-access-token',
    oab_id_token_legacy: 'oab-id-token',
    oab_organizacao_padrao: 'oab-organizacao-padrao',
    oab_setor_padrao: 'oab-setor-padrao',
    oab_orgs_user_permission: 'oab_orgs_user_permission',
    oab_refresh_token: 'oab-refresh-token'
};
